import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_SettingsRegisterMail = _resolveComponent("SettingsRegisterMail")!
  const _component_SettingUpdateMailPassword = _resolveComponent("SettingUpdateMailPassword")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", { key: _ctx.refreshKey }, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          active: _ctx.config.accountingMail,
          "onUpdate:active": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config.accountingMail) = $event)),
          dialogBind: _ctx.dialogBind,
          closeOnValid: false,
          hideMoreVert: true,
          hidePrevious: true,
          onUpdateProfile: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickValidBtbDialog())),
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetDialog())),
          onPrevious: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetStep()))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "px-6 pb-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window, {
                  modelValue: _ctx.step,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step) = $event)),
                  style: {"min-width":"600px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: 0 }, {
                      default: _withCtx(() => [
                        (_ctx.config.accountingMailConfig.users.length)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.config.accountingMailConfig.users, (user, i) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: i,
                                class: "mb-2 oss-list-item-xl"
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { class: "d-flex flex-grow-0 flex-shrink-1" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: "$oss-edit",
                                            size: "small",
                                            onClick: ($event: any) => ((_ctx.step = 2), (_ctx.index = i))
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, { class: "d-flex flex-grow-0 flex-shrink-1" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn_trash, {
                                            size: "small",
                                            onClick: ($event: any) => (_ctx.removeAccountingEmail(i))
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(user.email), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 1 }, {
                      default: _withCtx(() => [
                        (_ctx.step === 1)
                          ? (_openBlock(), _createBlock(_component_SettingsRegisterMail, {
                              key: 0,
                              ref: "settingsRegisterMail",
                              config: _ctx.config,
                              profileId: _ctx.profileId,
                              companyId: _ctx.companyId,
                              mailUsage: 'accountingMail',
                              onOnUpdate: _cache[0] || (_cache[0] = ($event: any) => {
                                _ctx.refresh();
                                _ctx.step = 0;
                            }),
                              onCurrentStep: _cache[1] || (_cache[1] = ($event: any) => (_ctx.settingsRegisterMailStep = $event)),
                              onDisplayValid: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayValid = $event))
                            }, null, 8, ["config", "profileId", "companyId"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SettingUpdateMailPassword, {
                          ref: "settingUpdateMailPassword",
                          config: _ctx.config,
                          profileId: _ctx.profileId,
                          mailUsage: 'accountingMail',
                          index: _ctx.index,
                          onOnUpdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refresh())),
                          onDisplayValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.displayValid = $event))
                        }, null, 8, ["config", "profileId", "index"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["active", "dialogBind"])
      ]))
    : _createCommentVNode("", true)
}